import * as e from "react";
const d = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 10.5a2 2 0 012-2h4v4a1 1 0 11-2 0v-2H9v2a1 1 0 11-2 0v-2z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 8.5h4a2 2 0 012 2v2a1 1 0 11-2 0v-2h-2v2a1 1 0 11-2 0v-4z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.58 14.482c-2.67-.42-7.506-.88-13.063-.003-.864.136-1.517.912-1.517 1.86v4.116a1 1 0 11-2 0v-4.117c0-1.858 1.298-3.534 3.206-3.835 5.826-.918 10.884-.437 13.685.004 1.875.295 3.109 1.934 3.109 3.74v4.207a1 1 0 11-2 0v-4.208c0-.915-.607-1.636-1.42-1.764z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.5 7.5a3 3 0 013-3h11a3 3 0 013 3v6h-2v-6a1 1 0 00-1-1h-11a1 1 0 00-1 1v6h-2v-6zM3 18a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1z",
      fill: "#2d6ded"
    }
  )
), v = d;
export {
  v as default
};
